/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import {App} from '../App'
import {useAuth2} from '../modules/authv2/Auth2Provider'
import {DocumentStatusPage} from '../modules/document-status/DocumentStatusPage'
import {VistaAdicionalPage} from '../modules/vistaadicional/VistaAdicionalPage'
import {AuthCallback} from './AuthCallback'
import {PrivateRoutes} from './PrivateRoutes'
import {ProtectedRoute} from './ProtectedRoute'
import { Redirect } from './Redirect'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {selectedRole} = useAuth2()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='auth/callback' element={<AuthCallback />} />

          {/* Rutas protegidas */}
          <Route element={<ProtectedRoute />}>
            {/* REDIRECIONAMIENTO */}
            <Route path='/redirect' element={<Redirect />} />

            <Route path='document-status/:id' element={<DocumentStatusPage />} />
            <Route path='vista/:url' element={<VistaAdicionalPage />} />
            <Route
              path='*'
              element={<PrivateRoutes userRol={selectedRole ? selectedRole : ''} />}
            />
            <Route index element={<Navigate to='/dashboard' replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
